import AbstractEntity from "../AbstractEntity";

export default class OrderItem extends AbstractEntity {
    _id;
    _price;
    _enabled;
    _orderId;
    _defaultItemId;


    getId() {
        return this._id;
    }

    getPrice() {
        return this._price;
    }

    isEnabled() {
        return this._enabled;
    }

    getOrderId() {
        return this._orderId;
    }

    getDefaultItemId() {
        return this._defaultItemId;
    }

    getClassName() {
        return "order_item";
    }
}